import { Checkbox } from "@rio-cloud/rio-uikit";
import { ChangeEvent, useEffect, useState } from "react";
import UptimeAssetRow from "./UptimeAssetRow";
import { Asset } from "../../../models/asset";

import "../styles.scss";

const LIMIT = 100;

interface UptimeTagRowProps {
	tagId: string;
	tagName: string;
	isChecked: boolean;
	assets: Asset[];
	selectedAssetIds: Set<string>;
	onTagSelect: (event: ChangeEvent<HTMLInputElement>) => void;
	isAssetChecked: (assetId: string) => boolean;
	onAssetSelect: (assetId: string) => void;
	searchQuery: string;
	viewMode: string;
}

const UptimeTagRow = ({
	tagId,
	tagName,
	isChecked,
	assets,
	selectedAssetIds,
	onTagSelect,
	isAssetChecked,
	onAssetSelect,
	searchQuery,
	viewMode,
}: UptimeTagRowProps) => {
	const [page, setPage] = useState(1);
	
	const filteredAssets = assets.filter((asset) => {
		if (
			searchQuery && 
			viewMode === "assets" && 
			(asset.chassis?.toLowerCase().includes(searchQuery.toLowerCase()) ||
				asset.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
				asset.licensePlate?.toLowerCase().includes(searchQuery.toLowerCase()))
		) return true;
		else if (!searchQuery || viewMode === "tags") return true;
		else return false;
	});
	
	const [isExpanded, setIsExpanded] = useState(searchQuery && filteredAssets.length > 0 ? true : false);

	useEffect(() => {
		setIsExpanded(searchQuery && filteredAssets.length > 0 ? true : false);
	}, [searchQuery]);

	return filteredAssets.length > 0 ? (
		<div
			key={tagId}
			style={{ height: isExpanded ? undefined : "41px" }}
			className={`TreeNodeContainer user-select-none overflow-hidden ${isExpanded ? "open" : ""}`}
		>
			<div className="TreeNode from-group" onClick={() => setIsExpanded(!isExpanded)}>
				<Checkbox
					className="TreeCheckbox"
					checked={isChecked || selectedAssetIds.size === filteredAssets.length}
					indeterminate={selectedAssetIds.size > 0 && selectedAssetIds.size < filteredAssets.length}
					onChange={(e) => {
						e.stopPropagation();
						onTagSelect(e);
					}}
				/>
				<div className="TreeLabel">
					<div className="TreeLabelName">
						<div className="TreeLabelNameText display-flex">
							<div className="TreeLabelNameTextHeadline">{tagName}</div>
							<div className="TreeLabelCount label margin-left-10 margin-right-10 label-muted label-filled label-condensed">{filteredAssets.length}</div>
						</div>
						<div
							className={`margin-inline-10 rioglyph text-size-12 ${isExpanded ? "rioglyph-chevron-up" : "rioglyph-chevron-down"}`}
						/>
					</div>
				</div>
			</div>

			{filteredAssets
				.slice(0, page * LIMIT)
				.map((asset) => <UptimeAssetRow
					key={asset.id}
					asset={asset}
					tagName={tagName}
					isTagSelected={isChecked}
					isChecked={isAssetChecked(asset.id)}
					onAssetSelect={onAssetSelect}
				/>)}

			{filteredAssets.slice(0, page * LIMIT).length < filteredAssets.length &&
				<div
					className="LoadMore cursor-pointer text-center py-8 text-color-primary"
					onClick={() => setPage(prev => prev + 1)}
				>Carregar mais</div>
			}
		</div>
	) : null;
};

export default UptimeTagRow;
